export default {
    googlePlayAppLink: 'https://play.google.com/store/apps/details?id=net.workout.lose.weight.fitness.fit.coach',
    appStoreAppLink: 'https://apps.apple.com/app/fitness-coach-diet-fitcoach/id1438092960',
};
